// extracted by mini-css-extract-plugin
export default {"root":"Content_root__HFbxU","container":"Content_container__FR-cJ","center":"Content_center__rVjr0"};